import { render, staticRenderFns } from "./CampaignList.vue?vue&type=template&id=0a006fe8&scoped=true"
import script from "./CampaignList.vue?vue&type=script&lang=ts"
export * from "./CampaignList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a006fe8",
  null
  
)

export default component.exports